import React from 'react'
import { Form, Message } from 'semantic-ui-react'
import styled from 'styled-components';

import { __ } from '~/i18n'
import BlockingButton from '~/components/blocking-button'
import Link from '~/components/link'
import { StyledForm } from '~/components/form'

const FormContainer = styled.div`
  text-align: left;
`;


export default class ApplyDiscount extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showInput: false,
      inputCode: '',
      prevActiveCart: props.activeCart
    }
  }

  static getDerivedStateFromProps(props, state) {
    const { activeCart } = props;
    const { prevActiveCart } = state;
    if(activeCart && prevActiveCart && activeCart.id === prevActiveCart.id && prevActiveCart.discounts && activeCart.discounts && activeCart.state !== 'ordered') {
      if(activeCart.discounts.length > prevActiveCart.discounts.length) {
        return {showInput: false, inputCode: '', prevActiveCart: activeCart};
      } else if (activeCart.discounts.length !== prevActiveCart.discounts.length) {
        return {prevActiveCart: activeCart}
      }
    } else if(activeCart && prevActiveCart && activeCart.id !== prevActiveCart.id) {
      return {showInput: false, inputCode: '', prevActiveCart: activeCart};
    }
    return null;
  }

  showInput = (e) => {
    e.preventDefault();

    this.setState({showInput: true})
  };

  applyCode = (e) => {
    e.preventDefault();
    const { onApply } = this.props;

    onApply(this.state.inputCode);
  };

  handleChange = (event, data) => {
    this.setState({inputCode: data.value.toUpperCase()});
  };

  render () {
    const { showInput, inputCode } = this.state;
    const { error, loading } = this.props;

    return (
      <div>
        { !showInput ? <Link href="#" onClick={ this.showInput }>{__('Have a discount code?')}</Link> : null }
        {
          showInput ? (
            <FormContainer>
              <StyledForm>
                <Form.Input
                  label={ __('Discount code') }
                  placeholder={ __('Discount code') }
                  action={
                    <BlockingButton
                      basic={ true }
                      color={ 'green' }
                      onClick={ this.applyCode }
                      loading={ loading }
                    >
                      { __('Apply') }
                    </BlockingButton>
                  }
                  onChange={ this.handleChange }
                  value={ inputCode }
                  error={ !!error }
                />
                {error ?
                  <Message
                    error
                    visible
                  >
                    { error }
                  </Message>
                 : null}
              </StyledForm>
            </FormContainer>
            )
            : null
        }
      </div>
    )
  }
}
